<v-loading></v-loading>
<div class="main">
	
	<router-outlet></router-outlet>
</div>
<app-custom-toaster></app-custom-toaster>
